/**
 * Created by ran on 29/11/2017.
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { environment } from "../../environments/environment";

@Injectable()

export class BackendService {
    endpoint: string;

    constructor(
        private http: HttpClient
    ) {
        // this.endpoint = 'http://localhost:8080/api';
        this.endpoint = environment.backendBaseUrl;
    }

    generateAvatar(name: string) {
        const url = this.endpoint + 'api/v2.0/generateThumbnail/';
        name = name.replace(' ', '+');
        return this.http.get((url + name))
            .map(thumbnail => {
                console.debug(thumbnail['url']);
                return thumbnail['url'];
            });
    }

    getFBPages(FBtoken: string) {
        // let token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2dpZ21hc3Rlci5ldS5hdXRoMC5jb20vIiwic3ViIjoiZmFjZWJvb2t8MTA2Njk5NDg3MDAyNzk5OSIsImF1ZCI6Imt3MW8wNlh2S3JydHE1YnFtb1NRWmFtbkNUZVNIMXdjIiwiaWF0IjoxNTA5NzQ0NzMzLCJleHAiOjI1MDk3NDQ3MzJ9.KxAH9v-2UbJRV096mAnvi6or3VZFBQTcWqMc3QFm2rY'
        const url = this.endpoint + 'api/v2.0/getFBPagesforArtist';
        console.log(url);
        return this.http.get(url, {
            params: new HttpParams().set('FBtoken', FBtoken),
            // headers: new HttpHeaders().set('Authorization', 'Bearer ' + token)
        })
            .map(response => {
                console.debug(response);
                return response;
            })
    }

    getWeather(data) {
        const url = this.endpoint + 'api/v2.0/getWeather';
        return this.http.post(url, data)
            .map(response => {
                console.debug('Got Weather Data from API');
                return response;
            });
        // .publishReplay(1) // for caching
        // .refCount();
    }

    updateSocialLinksForArtist(id, data) {
        console.info('Calling Backend API to Update Social Links');
        const url = this.endpoint + 'api/v2.0/updateSocialLinksForArtist/' + id;
        return this.http.post(url, data);
        // .publishReplay(1) // for caching
        // .refCount();
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/backend-service.ts